import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, Pittogrammi, PittogrammiLng } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class PittogrammiService extends CrudGenericsService<Pittogrammi, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/Pittogrammi`);
    this.base = `${env.apiUrl}/api/Pittogrammi/`;
  }
  GetAllLng(): Observable<PittogrammiLng[]> {
    const u = `${this.base}GetAllLng`;
    return this.http.get<PittogrammiLng[]>(u);
  }
  GetArticoliPittogrammi_ByArticolo(id: number): Observable<PittogrammiLng[]> {
    const u = `${this.base}GetArticoliPittogrammi_ByArticolo`;
    return this.http.get<PittogrammiLng[]>(u);
  }
}
